import React, { useState } from 'react';
import { Shield, Heart, Users, Target, Zap, Filter } from 'lucide-react';
import { Link } from 'react-router-dom';
import { dojoData } from '../mock';

const About = () => {
  const { about, faq } = dojoData;
  const [selectedCategory, setSelectedCategory] = useState('Débuter l\'Aïkido');
  
  // Extract unique categories from FAQ
  const categories = [...new Set(faq.flatMap(item => item.categories))];
  
  // Filter FAQ based on selected category
  const filteredFaq = faq.filter(item => item.categories.includes(selectedCategory));

  const benefitIcons = {
    0: Shield,
    1: Target,
    2: Heart,
    3: Zap,
    4: Users
  };

  return (
    <section id="about" className="section-padding section-dark">
      <div className="container">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-6" style={{ hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>{about.title}</h2>
          <p className="body-large max-w-2xl mx-auto" style={{ color: 'var(--text-on-dark)' }}>
            {about.description}
          </p>
          <p className="body-large max-w-2xl mx-auto mt-4" style={{ color: 'var(--text-on-dark)' }}>
            Nous pratiquons des techniques à mains nues et avec des <a style={{ color: '#d4d4d8', textDecoration: "underline" }} href="/faq#cat-8-q-0-quelles-armes-utilise-t-on-en-aikido">armes traditionnelles (bokken, jo, tanto)</a>.
          </p>
        </div>

        {/* Philosophy Statement */}
        <div className="text-center mb-8 p-8 border rounded-lg card-dark">
          <blockquote className="body-large italic" style={{ color: 'var(--text-on-dark)' }}>
            "{about.philosophy}"
          </blockquote>
        </div>
        <div className="text-center mt-8 mb-8 space-y-6">
          <div>
            <p className="body-medium mb-4" style={{ color: 'var(--text-on-dark)' }}>
              Découvrez qui vous enseignera et guidera votre progression.
            </p>
            <Link to="/professeurs" className="btn-secondary">
              Nos Professeurs
            </Link>
          </div>
	  </div>

        {/* Martial Arts Styles */}
        {/* <div className="mb-16">
          <h3 className="heading-2 text-center mb-12">Martial Arts We Teach</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {about.styles.map((style, index) => (
              <div key={index} className="card-dark p-8 text-center rounded-lg">
                <h4 className="heading-3 mb-4" style={{ color: 'var(--brand-primary)' }}>
                  {style.name}
                </h4>
                <p className="body-small" style={{ color: 'var(--text-on-dark)' }}>
                  {style.description}
                </p>
              </div>
            ))}
          </div>
        </div> */}

        {/* Benefits Grid */}
        <div>
          <h3 className="heading-2 text-center mb-12" style={{ hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>Pourquoi s'entraîner avec nous</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {about.benefits.map((benefit, index) => {
              const IconComponent = benefitIcons[index];
              return (
                <div key={index} className="flex items-start gap-4 p-6 card-dark rounded-lg">
                  <div className="flex-shrink-0 p-3 rounded-full"
                       style={{ backgroundColor: 'var(--brand-primary)' }}>
                    <IconComponent size={24} style={{ color: 'white' }} />
                  </div>
                  <div>
                    <p className="body-medium" style={{ color: 'var(--text-on-dark)' }}>{benefit}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Testimonials */}
        {/* <div className="mt-16">
          <h3 className="heading-2 text-center mb-12">What Our Students Say</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {dojoData.testimonials.map((testimonial, index) => (
              <div key={index} className="card-dark p-8 rounded-lg">
                <div className="mb-4">
                  <div className="flex gap-1 mb-4">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <span key={i} style={{ color: 'var(--brand-primary)' }}>★</span>
                    ))}
                  </div>
                  <p className="body-small italic mb-4" style={{ color: 'var(--text-on-dark)' }}>
                    "{testimonial.text}"
                  </p>
                </div>
                <div className="border-t pt-4" style={{ borderColor: 'var(--border-light)' }}>
                  <p className="font-semibold" style={{ color: 'var(--brand-primary)' }}>
                    {testimonial.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div> */}
        {/* FAQ Section */}
        <div className="mt-16">
          <h3 className="heading-2 text-center mb-12" style={{ hyphens: 'none', wordBreak: 'normal', overflowWrap: 'break-word' }}>Questions fréquentes</h3>
          
          {/* Filter Controls */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <div className="flex items-center gap-2">
              <Filter size={20} style={{ color: 'var(--text-on-dark)' }} />
              <span className="body-small" style={{ color: 'var(--text-on-dark)' }}>Filtrer par catégorie :</span>
            </div>
            {categories.map(category => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 rounded border transition-all ${
                  selectedCategory === category 
                    ? 'btn-primary' 
                    : 'border-opacity-50 hover:border-opacity-100'
                }`}
                style={{
                  ...(selectedCategory !== category && {
                    backgroundColor: 'transparent',
                    color: 'var(--text-on-dark)',
                    borderColor: 'var(--border-medium)'
                  })
                }}
              >
                {category}
              </button>
            ))}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-6">
              {filteredFaq.filter((_, index) => index % 2 === 0).map((item, index) => (
                <div key={index * 2}>
                  <h4 className="font-semibold mb-2" style={{ color: 'var(--brand-primary)' }}>
                    {item.question}
                  </h4>
                  <p className="body-small" style={{ color: 'var(--text-on-dark)' }}>
                    {item.answer}
                  </p>
                </div>
              ))}
            </div>
            <div className="space-y-6">
              {filteredFaq.filter((_, index) => index % 2 === 1).map((item, index) => (
                <div key={index * 2 + 1}>
                  <h4 className="font-semibold mb-2" style={{ color: 'var(--brand-primary)' }}>
                    {item.question}
                  </h4>
                  <p className="body-small" style={{ color: 'var(--text-on-dark)' }}>
                    {item.answer}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Links to Additional Pages */}
        <div className="text-center mt-12 space-y-6">
          <div>
            <p className="body-medium mb-4" style={{ color: 'var(--text-on-dark)' }}>
              Plus de questions ? Consultez notre section FAQ complète.
            </p>
            <Link to="/faq" className="btn-secondary">
              FAQ Complète
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
